
import Multiselect from 'vue-multiselect'
import { DEFAULT_RADIUS } from '../../../util/constants'
 export default {
  components: {
    Multiselect
  },
  props: {
    tab: {
      type: String,
      default: 'region'
    },
    type: {
      type: String,
      default: 'pickup'
    },
    routeValidation: {
      type: Boolean,
      default: false
    },
    isTruck:{
      type: Boolean,
      default: false
    },
    filterProp: {
      type: Object,
      default: ()=>{}
    },
    filterPropState: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      loading: false,
      // statesList: [],
      selectedStates: [],
      suburbs: [],
      DEFAULT_RADIUS,
      valueString: 'Any',
      filter: {
        suburb: '',
        radius: this.tab === 'region'? DEFAULT_RADIUS : null
      }
    };
  },
  watch: {
    filter : {
      handler() {
        this.handleChange();
        this.getValueString()
        },
      deep: true,
      immediate: true
    },
    filterProp: {
      handler() {
        if(this.tab !== 'state'){

        if (this.filterProp?.type ||  this.filterProp?.radius) {
          if (this.filterProp.type) {
            this.getSuburbs(this.filterProp.type.toString(), true, this.filterProp?.radius || DEFAULT_RADIUS)
          }
        }
        else {
          const tempFilter = {
            suburb : null,
            radius : DEFAULT_RADIUS
          }
            this.filter = tempFilter;
          }
        this.getValueString()

      }
    },
      deep: true,
      immediate: true
    },
    filterPropState: {
      handler() {
        if(this.tab === 'state'){
        if (this.filterPropState !== null) {
            this.selectedStates = this.filterPropState
        } else {
          this.selectedStates = []
        }
        this.$emit('value-changed', this.selectedStates)
      }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    setFilter(suburb) {
      this.filter = {...this.filter, suburb}
    },
    customLabel({ suburb, postcode }) {
      return `${suburb} – ${postcode}`
    },
    getValueString(){
      this.valueString  = (this.filter.suburb && this.filter.suburb.suburb) ? (this.filter.suburb.suburb + ((this.tab !== 'route')? (', ' + (this.filter.radius ? this.filter.radius + 'km': DEFAULT_RADIUS +' km')) : '')): 'Any'
      
    },
    handleChange () {
      if(this.tab === 'state'){
        this.$emit('value-changed', this.selectedStates)
      }
      else {
        this.$emit('value-changed', this.filter)
      }
    },
    getSuburbs (searchString, defaultSearch = false, radius= DEFAULT_RADIUS) {
      const payload = {
        searchString,
      }
      if (searchString && searchString.length > 1) {
        this.loading = true
        this.$store.dispatch('lookup/getSuburbs', payload)
          .then((res) => {
            if (res) {
              if (defaultSearch) {
                if (res.length > 0) {
                  const result = res.filter(x => x.suburb.toLowerCase() === searchString.toLowerCase() || x.suburb.toLowerCase() === searchString.toLowerCase() + ' city' )
                  if (result.length > 0) {
                    this.filter = {}
                    this.filter.suburb = result[0];
                    this.filter.radius = radius;
                  }
                }
                this.$emit('value-changed', this.filter)
              }
              this.suburbs = res;
            }
              this.loading = false
          });
      }
    }
  }
}
